import React from 'react';
import { Button, Col, Row, Table, Typography } from 'antd';
import { useSelector } from 'react-redux';
import locale from 'antd/es/locale/pt_BR';

import { useSolicitacoesDeAtivacao } from './useSolicitacoesDeAtivacao';
import { stateGlobal } from '../../../interfaces/Global';

const { Text } = Typography;

const SolicitacoesDeAtivacao: React.FC = () => {

    const {
        clickBotaoEditarUsuario,
        hasSelectedEdit,
        loadingTable,
        onclickTable,
        rowSelection,
        dadosTabelaState,
        columns,
        refContagemDoFiltro,
        handleResetRowSelection,
    } = useSolicitacoesDeAtivacao();

    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <>
            <div
                style={{
                    position: 'fixed',
                    zIndex: 2,
                    paddingTop: 24,
                    paddingBottom: 10,
                    paddingLeft: 24,
                    paddingRight: 10,
                    margin: -24
                }}
            >
                <Row>
                    <Col>
                        <Button type="primary"
                            style={{ marginRight: 5, marginBottom: 5 }}
                            className="btn_warning_cewuyfgfvewofc" onClick={clickBotaoEditarUsuario} disabled={!hasSelectedEdit}
                        >
                            Editar
                        </Button>
                    </Col>
                </Row>
            </div>

            <Table
                style={{
                    marginTop: 50
                }}
                className='marginTopTables'
                rowClassName={(record, index) => "ativoList"}
                rowKey={(record) => record.id}
                loading={loadingTable}
                onRow={(record, rowIndex) => {
                    return {
                        onClick: event => { onclickTable(record, rowIndex) },
                    };
                }}
                rowSelection={rowSelection}
                columns={columns} dataSource={dadosTabelaState}
                scroll={{ x: 1000 }}
                onChange={
                    (pagination, filters, sorter, extra) => {
                        handleResetRowSelection();
                        refContagemDoFiltro.current = extra.currentDataSource
                    }
                }
                title={(registros) => {
                    return (
                        <div
                            style={{
                                backgroundColor: propsState.theme === 'light' ? '#FAFAFA' : '#1D1D1D',
                                padding: 10,
                                margin: -8,
                                marginBottom: 0.5
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                footer={(registros) => {
                    return (
                        <div
                            style={{
                                textAlign: 'end'
                            }}
                        >
                            <Text>
                                {`Mostrando: ${registros.length} de ${refContagemDoFiltro.current.length === 0 ?
                                    dadosTabelaState.length :
                                    refContagemDoFiltro.current.length} num total de ${dadosTabelaState.length} `}
                            </Text>
                        </div>
                    )
                }}
                size="small"
                pagination={{
                    locale: { items_per_page: '' },
                    showSizeChanger: true,
                    defaultPageSize: 100,
                    position: ['topRight', 'bottomRight'],
                    pageSizeOptions: ['10', '20', '50', '100']
                }}
                locale={locale.Table}
            />
        </>
    );
}

export default SolicitacoesDeAtivacao;
